export const TITLE = '@HeaderTitle/TITLE'
